import { connect } from 'react-redux'
import firebase from 'firebase'
import 'firebase/firestore'

import {
  fetchActivities
} from '../actions'

import MainPage from '../components/MainPage'


function mapStateToProps(state) {
 
  const { competencies } = state.competencies
  const assessmentId = state.selectedAssessment.id

console.log(state.selectedAssessment)

  return {
    assessmentId,
    competencies
  }
}

const mapDispatchToProps = (dispatch) => {
    const firestore = firebase.firestore()
    return {
        fetchActivities: (assessmentId) => { dispatch(fetchActivities(assessmentId, firestore)) }
    }
}

const AsyncApp = connect(
    mapStateToProps,
    mapDispatchToProps
)(MainPage)

export default AsyncApp


// WEBPACK FOOTER //
// ./src/modules/competencies/containers/AsyncApp.js